/**
 * Which sections a compare column shows. Plain functions (no React) so the
 * export gather can use them in the browser and in the export worker alike.
 */
import type { SectionResponse } from '../types';

// Sections with no usable content are excluded from the tree + the count.
export function hasContent(s: SectionResponse): boolean {
  return !!((s.content_text && s.content_text.trim()) || (s.content_xml && s.content_xml.trim()));
}

/** All selectable section_numbers for a drug (content-bearing), in source order. */
export function sectionNumbersOf(sections: SectionResponse[] | undefined): string[] {
  return (sections ?? [])
    .filter(hasContent)
    .map((s) => s.section_number || `__${s.title ?? ''}`)
    .filter(Boolean);
}

/** Resolve the effective shown-set: explicit selection, or all when undefined. */
export function effectiveSelection(
  sections: SectionResponse[] | undefined,
  selected: string[] | undefined,
): Set<string> {
  return new Set(selected ?? sectionNumbersOf(sections));
}
